import { componentsScope } from "../../utils/logger";

export const runtimeScope = componentsScope.scope("define-element");
